var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareWhiteArown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_4330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.00008 6.99939H13.8301V5.41339C13.8302 5.01789 13.9475 4.63129 14.1673 4.30247C14.387 3.97365 14.6994 3.71738 15.0648 3.56604C15.4302 3.4147 15.8322 3.37509 16.2201 3.45223C16.608 3.52936 16.9644 3.71977 17.2441 3.99939L23.1241 9.87838C23.6865 10.441 24.0024 11.2039 24.0024 11.9994C24.0024 12.7949 23.6865 13.5578 23.1241 14.1204L17.2441 19.9994C16.9644 20.279 16.608 20.4694 16.2201 20.5465C15.8322 20.6237 15.4302 20.5841 15.0648 20.4327C14.6994 20.2814 14.387 20.0251 14.1673 19.6963C13.9475 19.3675 13.8302 18.9809 13.8301 18.5854V16.9994H8.00008C6.40927 17.001 4.88407 17.6336 3.75919 18.7585C2.63432 19.8834 2.00167 21.4086 2.00008 22.9994C2.00008 23.2646 1.89472 23.5189 1.70719 23.7065C1.51965 23.894 1.2653 23.9994 1.00008 23.9994C0.734863 23.9994 0.480509 23.894 0.292973 23.7065C0.105434 23.5189 7.82013e-05 23.2646 7.82013e-05 22.9994V15.9994C0.0027256 13.6132 0.951788 11.3256 2.63904 9.63835C4.3263 7.95109 6.61394 7.00203 9.00008 6.99939Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_4330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 1 24 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareWhiteArown);
export default __webpack_public_path__ + "static/media/shareWhiteArown.cbe412e1bfecddd72eae64d3c5c866d9.svg";
export { ForwardRef as ReactComponent };